<template>
  <SfTooltip :id="id" :data-testid="`${id}-tooltip`" :label="label" class="flex justify-center"><slot /></SfTooltip>
</template>

<script setup lang="ts">
import type { TooltipProps } from '~/components/ui/Tooltip/types';

defineProps<TooltipProps>();
</script>
